import { render, staticRenderFns } from "./pubHeaderNew.vue?vue&type=template&id=aea9c240&"
import script from "./pubHeaderNew.vue?vue&type=script&lang=js&"
export * from "./pubHeaderNew.vue?vue&type=script&lang=js&"
import style0 from "./pubHeaderNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pubHeaderNew.vue"
export default component.exports